import React from 'react';
import { Link, Navigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { haUnaVoce } from '../../utils/permessi';
import { vociDellaBarra } from '../../utils/vociBarra';
import { useSkin } from '../../moduli/useSkin';
import './styles/MyAccount.css';

/**
 * LA PORTA DI UNA PAGINA DEL CONTO: si apre a chi ha la voce.
 *
 * Il menu non mostra la voce a chi non ce l'ha (utils/myAccountSections.js,
 * Nova/MenuNova.js, Shell/NavBar.js), ma un indirizzo si scrive anche a
 * mano, e un segnalibro resta: la rotta deve chiederlo da sola. Qui si
 * chiede la stessa voce del menu, nello stesso posto (utils/permessi.js), e
 * chi non ce l'ha vede una pagina che lo dice, invece di una pagina vuota o
 * dell'errore di un servizio.
 *
 * `voce` e' il nome della voce del catalogo; un elenco vuol dire «ne basta
 * una» (la Cassa: versare o prelevare).
 *
 * `quando` (facoltativo) e' la sezione della skin che la pagina chiede
 * (moduli/leggi.js, skinConScommesse o skinConCasino): la voce del gettone e'
 * del livello e vale su tutte le skin, la sezione no. Se la skin l'ha spenta
 * si torna alla Home, come per Sport e Casino' (Shell/SeSezione.js).
 */
export default function ConVoce({ voce, quando, children }) {
  useSkin();
  if (quando && !quando()) return <Navigate to="/" replace />;
  if (haUnaVoce(voce)) return children;
  return <NonDisponibile />;
}

export function NonDisponibile() {
  const { t } = useTranslation();
  return (
    <div className="my-account-placeholder">
      <h1 className="my-account-panel-title">{t('Non disponibile')}</h1>
      <div className="my-account-placeholder-body">
        <p className="light-grey">
          {t('Questa pagina non è abilitata per il tuo conto. Se ti serve, chiedi a chi gestisce il tuo conto.')}
        </p>
        <p><Link to="/">{t('Torna alla Home')}</Link></p>
      </div>
    </div>
  );
}

/**
 * LA PRIMA PAGINA DEL CONTO: /my-account senza niente dopo.
 *
 * Era «Lista scommesse» scritto nella rotta: a chi non ha quella voce si
 * aprirebbe «non disponibile» come prima cosa del suo conto. Si va sulla
 * prima voce concessa, nell'ordine della striscia in alto; se non ce n'e'
 * nessuna, lo si dice.
 */
export function PrimaPaginaDelConto() {
  const gruppi = vociDellaBarra();
  const prima = gruppi.length && gruppi[0].voci.length ? gruppi[0].voci[0] : null;
  if (!prima) return <NonDisponibile />;
  return <Navigate to={prima.percorso} replace />;
}
